import { useStoreState } from '../../models/hooks';
import { AuthenticationStatus } from '../models/appModel';

export const useAuthenticationStatus = (): AuthenticationStatus => {
  return useStoreState((state) => state.app.authenticationStatus);
};
